module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Chapter One")]), _vm._v(" "), _c('b', [_vm._v("Battleground Italy: Salerno to Rome")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("002ww2/5 A German self-propelled gun crew discuss the situation with their "), _c('i', [_vm._v("Fallschirmjäger")]), _vm._v(" comrades among the ruins of the town of Cassino.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("001ww2/5 Men of the 2/6th Battalion, Queen’s Royal Regiment (West Surrey) advance past a pair of burning German PzKpfw IV tanks in the Salerno area, 22 September 1943.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("028ww2/5 On 12 September 1943, Otto Skorzeny and sixteen members of the Waffen SS joined "), _c('i', [_vm._v("Fallschirmjäger")]), _vm._v(" troops to rescue Mussolini in a high-risk glider mission. Ten DFS 230 gliders, each carrying nine soldiers and a pilot, towed by Henschel Hs 126 aircraft, took off from Pratica di Mare Air Base near Rome to rescue the deposed dictator Benito Mussolini. The rescue was a hugely publicised success. Above: Skorzeny has inserted himself next to Mussolini, pushing aside the planner of the raid, Major Mors.")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("031ww2/5 Skorzeny insisted on accompanying Mussolini, which endangered the mission’s success. After an extremely dangerous but successful takeoff, they flew to Pratica di Mare and then on to Vienna in a Heinkel He 111. On 14 September he met Hitler at Rastenburg.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("During the invasion and fighting in Sicily, King Victor Emmanuel III of Italy removed Mussolini and replaced him with Pietro Badoglio, who secretly negotiated a surrender with the Allies. The Germans’ reaction was to reinforce their forces in Italy, occupy Rome and set up a puppet state in the north of the country. The Allied invasion of mainland Italy began in September 1943. In the aftermath of Italy’s surrender, the Allies faced strong resistance from the Germans under "), _c('i', [_vm._v("Generalfeldmarschall")]), _vm._v(" Albert Kesselring, who resisted in strength the landing at Salerno, code named Operation Avalanche. Eventually, with twenty-four German divisions defending the country’s mountainous terrain, Italy became a slogging operation and a secondary theatre in the war against the Axis.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("027ww2/5 Gran Sasso, liberation for Benito Mussolini, he leaves the Hotel Campo Imperatore. Behind him to his left is Italian General Ferdinando Soleti, who had been involved in Mussolini’s removal. He had been forced into joining the operation to free the ex-dictator from the hotel on Gran Sasso. He ordered the "), _c('i', [_vm._v("carabinieri")]), _vm._v(" guards not to shoot, thus ensuring a bloodless rescue. Carrying the suitcase is "), _c('i', [_vm._v("SS-Sturmbannführer")]), _vm._v(" Karl Radl. Others are "), _c('i', [_vm._v("Fallschirmjäger")]), _vm._v(" and "), _c('i', [_vm._v("Waffen SS")]), _vm._v(" soldiers. "), _c('i', [_vm._v("SS-Hauptsturmführer")]), _vm._v(" Otto Skorzeny took the limelight and the credit.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-05.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("029ww2/5, 030ww2/5. After pulling off a precarious landing on sloping ground on a mountain side, the pilot of the Fieseler "), _c('i', [_vm._v("Storch")]), _vm._v(" light aircraft, "), _c('i', [_vm._v("Hauptmann")]), _vm._v(" Heinrich Gerlach, voiced his concerns that he did not think be could possibly take off with a passenger. When Skorzeny said that he’d be coming as well, Gerlach was horrified, as two passengers plus a pilot could be disastrous. But Otto Skorzeny was insistent. The look on Mussolini’s face says it all?")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("032WW2/4 Men of the 2nd Battalion, Northamptonshire Regiment, part of 17 Brigade, British 5th Division, wait to board landing craft at Catania, Sicily, for the invasion of Italy, that took place on 3 September at Reggio di Calabria, (Operation Baytown).")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("033ww2/5 The US Navy tank landing craft, LCT-222, lands a US Army jeep during the Salerno landings.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Invasion of Italy September 1943: troops from the 51st (Highland) Division boarding landing craft at Catania, 2 September 1943.")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("032ww/5 Americans landing artillery pieces during the invasion of mainland Italy at Salerno, September 1943. The military policeman (MP) in the foreground is ducking from a German shell exploding close by. The LCVPs (landing craft, vehicle, personnel) are from the USS "), _c('i', [_vm._v("James O’Hara")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-01.jpg"
    }
  })])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("050ww2/5, 051ww2/5. Landing British troops at Reggio di Calabria, Italy, as part of Operation Baytown. A US half-track, personnel carrier, has just driven off the LTC. The gun is a British 6-pounder anti-tank gun. Men of the 51st (Highland) Division coming ashore during the first day.")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("049ww2/5 September 1943 General Montgomery salutes his troops from a DUKW in the streets of Reggio di Calabria ‘on the toe of Italy’, 3 September 1943.")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("037ww2/5 Four weeks after the Allies landed in southern Italy the new Prime Minister of Italy, Marshal Pietro Bagdoglio, signed a full armistice document outlining details of the surrender aboard the battleship HMS "), _c('i', [_vm._v("Nelson")]), _vm._v(". Behind Bagdoglio and Eisenhower are: left to right, Air Chief Marshal Tedder, Lieutenant General Mason-MacFarlane and General Alexander. During secret surrender negotiations with the Allies, the Italian government offered to open the ports of Taranto and Brindisi on the eastern coast. Eisenhower quickly planned a third landing, codenamed ‘Slapstick’, to take advantage of the offer.")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("038ww2/5 General Arturo Scattini with the grenadiers of the "), _c('i', [_vm._v("Friuli")]), _vm._v(" Combat Group. (‘Friuli’ is an area of Northeast Italy.) General Arturo Scattini in Mussolini’s army was commander of the 80th La Spezia airborne division in Tunisia. He was captured by the British in May 1943 and interned. After the armistice he joined the Allies as a co-belligerent officer, returning to Italy in 1944 to command the "), _c('i', [_vm._v("Friuli")]), _vm._v(" Combat Group of the reconstituted Italian army. The officers and men are wearing British uniforms and webbing equipment, but retain their Italian badges of rank.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("035ww2/5 Lieutenant General Mark Clark on board his command ship, USS "), _c('i', [_vm._v("Ancon")]), _vm._v(", for the landings at Salerno, Italy, 12 September 1943.")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The USS "), _c('i', [_vm._v("Ancon")]), _vm._v(" after conversion from a troop transport to an amphibious command ship (AGC). Some of her civilian livery, although painted over, is still visible. Previously she was in service for the Panama Railroad Company.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("039ww2/5 Landings by the US 36th Infantry Division coming ashore at ‘Yellow Beach’. Shermans of the 191st and 751st Tank Battalions roll onto the beach from LSTs to support the infantry.")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("034ww2/5 British troops landing at Salerno with the help of American engineers, 9 September 1943.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("040ww2/5, A column of German Pzkfw IV panzers move to counter the Allied landings.")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("044ww2/5 Near the town of Salerno, 9 September 1943 (Operation Avalanche): a British 3-inch mortar team in action.")])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("041ww2/5 A German defence line on the Salerno bridgehead perimeter. The weapon is a grenade launcher.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("045ww2/5, 046ww2/5. A "), _c('i', [_vm._v("Nebelwerfer 41")]), _vm._v(" crew of four loading up the six barrels. Although it was referred to as a mortar, it was really a rocket tubular projector. The barrels are fired electrically, from a distance, as the crew took cover. They were never fired simultaneously, since the blast from six rockets at once would capsize the weapon. The order of fire was fixed at 1–4–6–2–3–5. The range was said to be about 7,760 yards. There could be either six or eight weapons to a battery. The battery officer has his arm raised and is yelling the command to fire.")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("By 11 September, four of the Fifth Army’s divisions were ashore, but five Panzer Divisions of the German Tenth Army were in place to resist their advance. The Northern Attack Force, British X Corps, were struggling to break out towards Naples. The US Sixth Corps, the Southern Attack Force, with its thirty-five mile wide front could not break out to the south. It meant that these two attack forces, widely spread as they were, could not support each other. Kesselring counter attacked Clark’s landings along the line of the River Sele on 12 September and almost succeeded in splitting the Salerno beachhead. However, Allied air and naval firepower broke up the German attack. On 14 September the Germans withdrew north and the Salerno beachhead was secure. Meanwhile, the Eighth Army was continuing to advance north against little resistance and on 20 September Montgomery and Clark’s armies met at Ponte Sele and by 5 October the Allies were entering Naples.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("On 8 September the British 2nd and 4th Parachute Brigades made an amphibious landing, followed by the remainder of the division landing at the port of Taranto. The commander, Major General Hopkinson, landed with the rest of the division and accepted the surrender of the Italian garrison, then ordered the division to advance northwards. Elements of the German "), _c('i', [_vm._v("1.Fallschirmjäger-Division")]), _vm._v(", set up defence positions and roadblocks to slow the British parachute troops. A German roadblock was set up near the town of Castellaneta. On 9 September the 10th Parachute Battalion attacked the roadblock, with Hopkinson up front along with them. During the fighting the general was hit and killed by machine-gun fire. Brigadier Ernest Down, commander of the 2nd Parachute Brigade, took over his command.")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("006ww2/5 Major General George F. Hopkinson, (14 December 1895 – 9 September 1943) commanded the 1st Airborne Division. He was killed in action in Italy. He was the only British Airborne general to be killed during the Second World War. He died fighting near the town of Castellaneta, Italy.")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("048ww2/5 New Zealand soldiers arrive at the port and city of Taranto, Italy, 14 October 1943.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("047ww2/5 It was not going to be easy for the Allies to fight their way towards Rome. The Germans made skilful use of the rivers and mountainous terrain to form defence lines. Men of the "), _c('i', [_vm._v("1.Fallschirmjäger Division")]), _vm._v(" are seen here setting up an ambush with their MG42 heavy machine gun.")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0023-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("042ww2/5 Members of 2 SAS on parade for an inspection by General Montgomery, following their successful operation behind enemy lines, helping in the capture of the port of Termoli in Italy. On the left is Major E Scratchley DSO, MC, commanding the SAS detachment. On the right is Captain Roy Farran holding a German MP40 ("), _c('i', [_vm._v("Maschinenpistole")]), _vm._v(" 40). Allies referred to it as a ‘"), _c('i', [_vm._v("Schmeisser’")]), _vm._v(". The winged sword/dagger cap badges on their sand coloured berets have been obliterated by the censor.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("051ww2/5 An American infantry patrol in the ruined square of Acerno, fourteen miles northeast of Salerno, passes an abandoned German 88mm anti-aircraft gun adapted for use in the anti-tank role. Allied tank crews in their Shermans dreaded coming up against this very effective weapon.")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("053ww2/5 Through the remainder of September the Allies pushed north through southern Italy. The American Fifth Army entered Naples on 1 October. To the east, also on 1 October, the British Eighth Army liberated Foggia.")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0026-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("059ww2/5 Grottaglie, Taranto, 15 September 1943, RAAF Padre, Squadron Leader John McNamara of Brunswick, Victoria, conducts mass outdoors for an Italian aircrew, two days after the Allies arrived. Most Italian forces changed sides to join the Allies, although some formations remained on the side of the Axis. In such situations conflict of conscience for some was inevitable; it could be allayed by Roman Catholic ritual. Note the two Italians standing guard with fixed bayonets either side of the altar, which has been set up in front of a roadside shrine.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("055ww2/5 The Volturno River 12 to 16 October 1943: An Ordnance QF 25-pounder on a Valentine tank chassis (named the ‘Bishop’ self-propelled gun) at an aerodrome near Grazzanise fires a round during the night barrage in preparation for the crossing of the Volturno by assault troops. The Bishop has been run up on the wreckage of a German aircraft to obtain more elevation.")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("060ww2/5 A German soldier killed by a shell explosion. He is wearing radio earphones and could have been operating as a spotter for the artillery at the time of his death.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("061ww2/5 An American gun crew operating a 105 mm howitzer from a half-track putting down suppressing fire for a river crossing.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("054ww2/5 American infantry crossing the Volturno River by rubber boat. Following the Allied invasion of Italy in September 1943, the German forces set up a series of defensive lines across Italy, intended to delay the Allied advance. The Volturno Line was the southernmost of these.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("062ww2/5 An American paratrooper demonstrates the process of removing a live S-mine. On the left is a Mark I trench knife.")])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The SMi-35 mine’s internal mechanism, together with the three-pronged pressure fuse. The safety pin for the fuse and the three removable plugs for the detonators are clearly visible. These diagrams were issued as part of a US Army field manual on mines in 1943")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("When triggered, these mines were launched into the air and then detonated at about three feet from the ground. The explosion projected a lethal spray of shrapnel in all directions.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("057ww2/5 American engineers had thrown bridges across the Volturno, some barely strong enough to carry armour. A soldier is walking backwards guiding a self-propelled gun across a foot at a time. Note a ‘drowned’ vehicle from a previous attempt to cross the fast flowing river.")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("056ww2/5 An amphibious operation was made by British Commandos at Termoli on the Adriatic coast. It took place on 3 October 1943, as part of the attack on the Volturno Line. This "), _c('i', [_vm._v("Pzkfw IV")]), _vm._v(" was knocked out south of Petacciate, beyond Termoli. The grave is of M. Muller, German Army. Numerous S Mines had been placed in and around the tank.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0030-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("070ww2/5 British troops crossing the Volturno River on a bridge laid by American engineers, 13 October 1943. The weather would deteriorate, changing from autumn rains to winter storms, washing away many of these crossing places.")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("072ww2/5 An action photograph of a Piat team of the 2/6th Battalion, The Queen’s Royal Regiment, hitting an enemy tank with a PIAT mortar projectile.")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The PIAT launched a 2.5 pound bomb using a cartridge in the tail of the projectile. It possessed a range of approximately 115 yards.")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Projector, Infantry, Anti Tank (PIAT) Mk I was a British man-portable anti-tank weapon.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0031-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("093ww2/5 Disabled and abandoned by its German crew, a PzKfw IV.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0032-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("058ww2/5 Infantry of the 8th Battalion, Royal Fusiliers, advance through the mud in the Volturno area.")])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0032-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("068ww2/5 Two German soldiers making themselves comfortable and enjoying a meal (bread and sausage?) in a defence position. They are covered by waterproof capes ("), _c('i', [_vm._v("Zelthahn")]), _vm._v(") lashed together to make a shelter.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0033-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("069ww2/5 A bipod mounted MG 42 operated by a crew in one of the defensive lines in southern Italy 1943.")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0033-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("136ww2/5 A German crew of a 75mm "), _c('i', [_vm._v("Panzerabwehrkanone")]), _vm._v(" (Pak) anti-tank gun build a simple camouflage cover to hide their weapon. To the eyes of an Allied Sherman tank crew it might appear as a lean-to shack against a dwelling.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0034-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("105ww2/5, 106ww2/5. On the approaches to San Pietro: troops of Battery D, 105th Anti-Aircraft Battalion on the slopes of 4,000 feet Monte Sammucro. Battery D guarding the bridge on the road to San Pietro.")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0034-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("107ww2/5 Major General Fred Livingood Walker, commanding 36th Infantry Division. The 36th incurred heavy losses in the fighting to capture San Pietro.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Battle of San Pietro was a fierce engagement that took place from 8–17 December 1943. Allied forces were attacking north against heavily fortified positions of the German Winter Line in and around the town of San Pietro, just south of Monte Cassino and approximately halfway between Naples and Rome. The eventual Allied victory in the battle was crucial in the drive to liberate Rome. It was also the first action in which the troops of the Royal Italian Army ("), _c('i', [_vm._v("Regio Esercito")]), _vm._v(") fought as co-belligerents of the Allies following the armistice and Italy changing sides.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0034-03.jpg"
    }
  })])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0035-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("100ww2/5 Paratroopers of the 504th Parachute Infantry Regiment (part of the 82nd Airborne Division) on the road to San Pietro, 17 December.")])])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0035-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("109ww2/5 Men of the 504th Regimental Demolition Platoon keep a wary eye while one of their team disarms S-mines on the slope of Hill 1017, November 1943.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("101ww2/5 Searching for mines with the SCR-625 detector, which discerned metallic mines six to twelve inches below the surface. Few mines were ever buried more than twelve inches below ground. In Italy, the SCR-625 proved to be far less effective due to a high iron content in the soil.")])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("102ww2/5 From the mountainous terrain it required seventy-two men to evacuate just one stretcher patient from the Battalion Aid Station to an ambulance. It reportedly took twelve to fifteen hours down rough tracks. Along the route of evacuation, there were three Aid Stations, each one supervised by a medical officer with facilities to administer first-aid treatment, plasma and hot drinks. These Aid Stations provided a resting place for the walking wounded.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("109ww2/5 In the operations during late December 1943 rain was almost constant, making travel difficult and the use of vehicles minimal. Pack mules were employed to get ammunition and supplies to the front line units.")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("113ww2/5 At the end of trail at San Pietro, stretchers bearing the wounded and the dead stopped. The wounded were hurried to the Aid Station and the dead taken by trucks for burial in the 36th Division cemetery located at Marzanello Nuovo, twenty-eight miles south along Route 6. The stretcher bearers seen here are men of the 141st Infantry Regiment, preparing the bodies of their dead comrades killed on Christmas Day 1943 for evacuation.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0038-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("099ww2/5 Cassino under fire in February during the dogged attempts by the Amercans to fight their way into the town. By this time the 1st Battalion of the 133rd Regiment, 34th Division was attacking Hill 175 to the right of the picture. Castle Hill (Hill 193) was captured and held against determined counterattacks by German paratroopers.")])])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Monte Cassino and the Gustav Line were assaulted four times by Allied troops between 17 January and 18 May,1944. On 16 May, soldiers from the Polish II Corps launched one of the final assaults on the monastery as part of a twenty-division assault. On 18 May the flag was raised over the ruins and the German Senger Line collapsed on 25 May. The German defenders were finally driven from their positions. The capture of Monte Cassino resulted in 55,000 Allied casualties. German losses were fewer, estimated at around 20,000 killed and wounded.")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("I10ww2/5 Two German paratroopers (one shouldering a paratrooper rifle – "), _c('i', [_vm._v("Fallschirmjägergewehr")]), _vm._v(" 42), with a pile of confiscated Italian weapons, steel helmets and equipment that included a motorcycle.")])])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0039-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Germans dug in along their defence lines, the foremost named the "), _c('i', [_vm._v("Gustav Line")]), _vm._v(", which, at its southern tip, was positioned around the mountains behind Cassino. Consequently the town was the site of fierce fighting in the Battles of Monte Cassino. On 15 February 1944 the abbey was deliberately targeted and destroyed in an Allied bombing raid. It was believed that the monastery was a strategic position occupied by the Germans. The works of art contained in the abbey were transferred to Rome by the Germans prior to the bombing, but some disappeared en route. On 15 March the town was completely razed to the ground by aerial bombardment and artillery fire, followed by an unsuccessful Allied attack. One-tenth, 2,026, of the town’s population of 20,000 were killed in the fighting.")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("114ww2/5 "), _c('i', [_vm._v("General der Panzertruppe")]), _vm._v(" Fridolin von Senger und Etterlin, commander of "), _c('i', [_vm._v("XIV.Panzerkorps")]), _vm._v(". Among its formations were the "), _c('i', [_vm._v("1.Fallschirmjäger Division")]), _vm._v(", the "), _c('i', [_vm._v("15.Panzergrenadier Division")]), _vm._v(" and the "), _c('i', [_vm._v("29.Panzergrenadier Division")]), _vm._v(". Interestingly, he was a lay member of the Roman Catholic Benedictine Order and spoke French and English.")])])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("115ww2/5 Major General Geoffrey Keyes commanded II Corps throughout the Italian Campaign. His first major battle was the Battle of San Pietro and later, with the 36th Infantry Division under command, his Corps took part in the controversial Battle of Rapido (actually the Gari River), part of the first Battle of Monte Cassino.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0040-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("116ww2/5 A mortar team assist the artillery in laying down fire to support the crossing of the Gari River by regiments of the 36th Infantry Division, 20/20 January 1944.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0041-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("111ww2/5 A defensive point on the Gustav Line. The Germans set their automatic weapons to provide supportive, covering fire for each position.")])])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0041-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("120ww2/5, 121ww2/5. Soldiers of the "), _c('i', [_vm._v("15.Panzergrenadier Division")]), _vm._v(" on the West bank of the Gari River collecting surrendering American survivors of the failed bridgehead. The Germans reported rounding up 500 prisoners from among the many dead from the US 141st, 142nd and 143rd Regiments. The 36th Division’s attack had been a costly failure, with casualties amounting to 143 killed, 663 wounded and 875 missing (captured or swept away in the river). A truce was declared the following day so that the American dead on the west bank could be collected.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0041-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Allies were attempting to establish a bridgehead in the vicinity of San Angelo to launch attacks on the Gustav Line near Monte Cassino. The assault was opposed by two battalions from the German "), _c('i', [_vm._v("15.Panzergrenadier Division")]), _vm._v(" under "), _c('i', [_vm._v("Generalmajor")]), _vm._v(" Eberhard Rodt. American troops suffered over 2,000 casualties in the failed assault.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0041-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("119ww2/5 "), _c('i', [_vm._v("Generalmajor")]), _vm._v(" Eberhard Rodt, commanding "), _c('i', [_vm._v("15.Panzergrenadier Division")]), _vm._v(".")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0042-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("117ww2/5 Stretcher bearers bringing back wounded in the 141st Infantry Regiment sector, 22 January. After two days of furious fighting the American losses were very high. Three of the battalions had each lost over half their number killed, wounded or captured.")])])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0042-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("123ww2/5 Staff Sergeant McCall, 143rd Infantry Regiment, 36th Infantry Division.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Staff Sergeant McCall’s Medal of Honor citation reads:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For conspicuous gallantry and intrepidity at risk of life above and beyond the call of duty. On 22 January 1944, Company F had the mission of crossing the Rapido River in the vicinity of San Angelo, Italy, and attacking the well-prepared German positions to the west. For the defense of these positions the enemy had prepared a network of machinegun positions covering the terrain to the front with a pattern of withering machinegun fire, and mortar and artillery positions zeroed in on the defilade areas. S/Sgt. McCall commanded a machinegun section that was to provide added fire support for the riflemen. Under cover of darkness, Company F advanced to the river crossing site and under intense enemy mortar, artillery, and machinegun fire crossed an ice-covered bridge, which was continually the target for enemy fire. Many casualties occurred on reaching the west side of the river and reorganization was imperative. Exposing himself to the deadly enemy machinegun and small arms fire that swept over the flat terrain, S/Sgt. McCall, with unusual calmness, encouraged and welded his men into an effective fighting unit. He then led them forward across the muddy, exposed terrain. Skillfully he guided his men through a barbed-wire entanglement to reach a road where he personally placed the weapons of his two squads into positions of vantage, covering the battalion’s front. A shell landed near one of the positions, wounding the gunner, killing the assistant gunner, and destroying the weapon. Even though enemy shells were falling dangerously near, S/Sgt. McCall crawled across the treacherous terrain and rendered first aid to the wounded man, dragging him into a position of cover with the help of another man. The gunners of the second machinegun had been wounded from the fragments of an enemy shell, leaving S/Sgt. McCall the only remaining member of his machinegun section. Displaying outstanding aggressiveness, he ran forward with the weapon on his hip, reaching a point 30 yards from the enemy, where he fired 2 bursts of fire into the nest, killing or wounding all of the crew and putting the gun out of action. A second machinegun now opened fire upon him and he rushed its position, firing his weapon from the hip, killing 4 of the guncrew. A third machinegun, 50 yards in rear of the first two, was delivering a tremendous volume of fire upon our troops. S/Sgt. McCall spotted its position and valiantly went toward it in the face of overwhelming enemy fire. He was last seen courageously moving forward on the enemy position, firing his machinegun from his hip. S/Sgt. McCall’s intrepidity and unhesitating willingness to sacrifice his life exemplify the highest traditions of the Armed Forces.")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0043-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("125ww2/5 Senior British commanders visiting the headquarters of the 2nd New Zealand Division, December 1943. Left: General Sir Alan Brooke, General Bernard Freyberg, and General Sir Harold Alexander. Alexander decided to move the New Zealanders from Eighth Army command on the Adriatic coast over to the west and General Mark Clark’s Fifth Army front. They were to attack Cassino, taking over from the severely battered US 36th Infantry Division.")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0043-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("126ww2/5 Lieutenant General Sir Bernard Freyberg VC. Freyberg insisted to Clark that the Benedictine Order monastery, which dominated the Liri Valley and town of Cassino, should be flattened by bombing before the New Zealand and Indian troops attacked. General Alexander, although expressing the opinion that it would be regrettable to destroy the monastery (built around AD 529), supported Freyberg’s insistence that reducing the abbey be considered a military necessity.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0043-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("128ww2/5 On 15 February American bombers dropped 1,400 tons of high explosives on the monastery causing widespread damage.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0044-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("127ww2/5,129ww2/5 New Zealand troops watching the bombing of the monastery 15 February. Three New Zealand battalions had been planned to attack the German positions immediately after the air strike, along with the 4th Indian Division’s attack on the monastery. Because of other set backs it did not happen until two days later.")])])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("An American B-17 climbs after dropping its bombload on the monastery.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0044-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("130ww2/5 Major General Howard Kippenberger, commander of the 2nd New Zealand Division was in favour of the controversial bombing:")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("It was impossible to ask troops to storm a hill surmounted by an intact building such as this, capable of sheltering several hundred infantry in perfect security from shellfire and ready at the critical moment to emerge and counter-attack. ... On the whole I thought it would be more useful to the Germans if we left it unbombed")]), _vm._v(".")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0045-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("131ww2/5, 132ww2/5, 133ww2/5. The raid failed to achieve its objective, as German paratroopers occupied the rubble five days after the bombing. This photo was probably taken in the town.")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0046-03.jpg"
    }
  })])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0047-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("112ww2/5 Soldiers of the "), _c('i', [_vm._v("1.Fallschirmjäger Division")]), _vm._v(" operating an MG42 on the Gustav Line before moving to the Cassino sector.")])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0047-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("135ww2/5 "), _c('i', [_vm._v("Generalleutnant")]), _vm._v(" Richard Heidrich, commander of the "), _c('i', [_vm._v("1.Fallschirmjäger")]), _vm._v(" Division, was fighting in the Gustav Line under the overall command of Fridolin von Senger und Etterlin’s "), _c('i', [_vm._v("XIV Panzer Corps")]), _vm._v(", when he was ordered to transfer to the critical Monte Cassino sector. During that period the German paratroopers fought against combined Allied forces from the British Empire, the United States, Poland and France. In May 1944 the Allies finally broke through at Cassino and, in conjunction with the Anzio beachhead, captured Rome. After a fighting withdrawal to the Arno River, Heidrich’s division took up positions on the Gothic Line of defence.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0047-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("134ww2/5 The destruction created by the bombing had transformed the monastery into a virtual fortress and the "), _c('i', [_vm._v("Fallschirmjäger")]), _vm._v(" lost no time in transforming it into an excellent defensive position. Now the defenders of the Gustav Line at Cassino had an even better view of Allied troop movements. Two paratroopers of the "), _c('i', [_vm._v("Fallschirmjäger MG Bataillon.1")]), _vm._v(" operate an MG42 machine gun.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0048-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("141ww2/5 It had been decided to carry on the bombing campaign with a raid to flatten the town of Cassino. For accurate bombing fair weather was needed and the first available date was 15 March 1944. A massive bombardment by medium and heavy bombers got underway at 8.30 am. First over the target were B-25 medium bombers of the 321st and 340th Bombardment Groups.")])])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0048-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("138ww2/5 Bombs falling in the fields in front of Cassino. Following sticks began plastering the town with high explosives. The Germans had evacuated the civilians in 1943.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0049-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("140ww2/5 in the centre, with black boots, Lieutenant General Oliver Leese, commanding the British Eighth Army, watches the bombing with three other British generals.")])])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0049-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("139ww2/5 Lieutenant General Ira C Eaker, commander of the Mediterranean Air Command, observing the bombardment from General Freyberg’s command post at Cervaro, three miles from Cassino.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0050-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("142ww2/5 New Zealand infantry advance yards at a time into ruins created by the bombing. Roads, destroyed and heavily cratered meant that tanks moved at a crawl, if at all. The Germans were spoiled for choice as to where to conceal machine guns and snipers.")])])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0050-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("143ww2/5 Shermans of the 19th NZ Armoured Regiment stuck in a queue and unable to move into Cassino because of the craters and debris from the bombing. Some of the first German prisoners from the town, paratroopers from "), _c('i', [_vm._v("2./FJR 3")]), _vm._v(" and "), _c('i', [_vm._v("I./FJR 3")]), _vm._v(".")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0051-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("166ww2/5 Men of "), _c('i', [_vm._v("II./FJR 3")]), _vm._v(" 8cm mortar team under the command of "), _c('i', [_vm._v("Feldwebel")]), _vm._v(" Kübrich laying down close fire support in the ruins of Cassino.")])])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0052-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("144ww2/5 Cavendish Road, leading up to the hills behind the bombed monastery, was strewn with burnt out Allied tanks. Abandoned Sherman and Stuart tanks were blown up by the Germans. The above Stuart tank had its left track blown off by a T-mine placed by "), _c('i', [_vm._v("Oberleutnant")]), _vm._v(" Eckel.")])])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0052-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("145ww2/5 "), _c('i', [_vm._v("Oberleutnant")]), _vm._v(" Raimund Eckel, commander of "), _c('i', [_vm._v("14.Kompanie, Fallschirmjäger Regiment 4")]), _vm._v(", received the Iron Cross First Class. He was also awarded two Silver Tank Destruction Badges (seen here worn on his right upper sleeve). Four other of his men were credited with destroying a tank each. The Allied view was that these had been abandoned by their crews and were simply blown up later, whereas Eckel had acted under battle conditions.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The track carved out from an existing footpath by Indian and New Zealand sappers was given the name ‘Cavendish Road’. It made possible for armour to climb the hills behind the monastery. Although sudden appearance of armour surprised the Germans the "), _c('i', [_vm._v("Fallschirmjäger")]), _vm._v(" defenders stopped the attack. The road became strewn with burnt out Sherman and Stuart tanks. The "), _c('i', [_vm._v("Panzerschrek")]), _vm._v(" was being used at this time by Eckel’s men.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0052-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The German hand-held recoiless anti-tank weapon, the improved "), _c('i', [_vm._v("Raketenpanzerbüchse 54")]), _vm._v(" with blast shield, commonly referred to as the "), _c('i', [_vm._v("Panzerschreck")]), _vm._v(" (‘tank fright)’.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0052-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("147ww2/5 Generals Freyberg, Clark and Major General Keightley of the British 78th Infantry Division conferring and they came to the conclusion that the Third Battle to take Cassino had failed. General Alexander would be informed. Freyberg asked for two more days to continue assaulting the German defences. The battle ended on 22 March 1944.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0053-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("148ww2/5 Men of the "), _c('i', [_vm._v("1.Fallschirmjäger Division")]), _vm._v(" pioneer battalion. A lull in attacks by the Allies signalled a temporary halt to offensive operations. The German paratroopers had successfully held their positions at Cassino against the heaviest bombing and shelling carried out to date in the Second World War.")])])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0053-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("150ww2/5 Although there was a quieting down of the fighting throughout April and into May 1944, sniping by both sides continued. Corporal Bartlett was a sniper with the 25th NZ Battalion, seen here among the ruins of Cassino town.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0053-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("149ww2/5 Like their enemy the German paratroopers, men of No.13 Platoon, 25th NZ Battalion, resting among the ruins of Cassino town at the end of the failed Third Battle. The battalion had suffered 30 per cent casualties.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0054-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Churchill to General Alexander")]), _vm._v(": "), _c('i', [_vm._v("I wish you would explain to me why this passage by Cassino Monastery Hill, etc, all on a front of two or three miles, is the only place you must keep butting at. About five or six divisions have been worn out going into these jaws. Of course I do not know the ground or battle conditions but, looking at it from afar, it is puzzling why, if the enemy can be held and dominated at this point, no attacks can be made on the flanks. It seems very hard to understand why this most strongly defended point is the only passage forward, or why, when it is saturated (in a military sense), ground cannot be gained on one side or the other. I have the greatest confidence in you and will back you up through thick and thin, but do try to explain to me why no flanking movements can be made")]), _vm._v(".")])])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("20 MARCH 1944")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0054-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("General Alexander to Prime Ministe")]), _vm._v("r: "), _c('i', [_vm._v("I reply to your telegram of 20 March. Along whole main battlefront from Adriatic to south coast there is only the Liri valley leading direct to Rome which is suitable terrain for development of our superiority in artillery and armour. The main highway, known as Route 6, is the only road except cart tracks, which leads from the mountains where we are into the Liri valley over the Rapido river. This exit into the plain is blocked and dominated by Monte Cassino, on which stands the monastery. Repeated attempts have been made to outflank Monastery Hill from the north, but all these attacks have been unsuccessful, owing to deep ravines, rocky escarpments, and knife-edges, which limit movements to anything except comparatively small parties of infantry, who can only be maintained by porters and to a limited extent by mules where we have managed under great difficulties to make some mule tracks... The destruction caused in Cassino to roads and movement by bombing was so terrific that the employment of tanks or any other fighting vehicles has been seriously hampered. The tenacity of these German paratroopers is quite remarkable, considering that they were subjected to the whole Mediterranean Air Force plus the better part of 800 guns under greatest concentration of fire-power which has ever been put down and lasting for six hours. I doubt if there are any troops in the world who could have stood up to it and then gone on fighting with the same ferocity they have. I am meeting Freyberg and the Army Commanders tomorrow to discuss the situation")]), _vm._v(". For the complete text of Alexander’s explanation see page 215 of "), _c('i', [_vm._v("The Battles for Monte Cassino")]), _vm._v(" by Jeffrey Plowman/Perry Rowe.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0054-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("153ww2/5 May 1944 the Allied commanders have just completed a plan to break the Gustav Line – Operation Diadem. Alexander stands flanked by his two Army generals: Lieutenant General Leese (British Eighth Army) on his right General Mark Clark (US Fifth Army) on his left. On the end is Lieutenant General Harding, Alexander’s Chief of Staff; behind is Brigadier General Lemnitzer, Alexander’s Deputy Chief of Staff.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0055-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("165ww2/5 "), _c('i', [_vm._v("Hauptmann")]), _vm._v(" Rudolf Rennecke, "), _c('i', [_vm._v("Kampfkommandant")]), _vm._v(" for the Cassino sector, briefs some battle commanders in the garage of the Palazzo Iucci: at his right shoulder is "), _c('i', [_vm._v("Oberleutnant")]), _vm._v(" Werner Pohl, "), _c('i', [_vm._v("2.Batterie")]), _vm._v(" of "), _c('i', [_vm._v("StuG Abteilung 242")]), _vm._v("; behind him is "), _c('i', [_vm._v("Oberleutnant")]), _vm._v(" Paul Renisch, "), _c('i', [_vm._v("9.Kompanie")]), _vm._v(", "), _c('i', [_vm._v("Fallschirmjäger Regiment 1")]), _vm._v("; "), _c('i', [_vm._v("Leutnant")]), _vm._v(" Siegfried Rammelt, commander of the regimental engineer platoon of "), _c('i', [_vm._v("Fallschirmjäger Regiment 3")]), _vm._v(". Behind Rennecke’s left shoulder is "), _c('i', [_vm._v("Feldwebel")]), _vm._v(" Kohl. After surviving the heaviest bombing and shelling they are about to face Operation Diadem.")])])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0055-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Operation Diadem began at 23:00 hrs on 11 May 1944 with the advance of the British 4th Infantry and 8th Indian Infantry Divisions. Support was supplied by the1st Canadian Armoured Brigade. The Garigliano and Rapido rivers were crossed and the defences in the Liri valley attacked. The Free French Corps pushed through the mountains on the left, supported by US II Corps along the coast. On 17 May, Polish II Corps on the right attacked Monte Cassino. When their position collapsed, the Germans fell back from the Gustav Line to the Hitler Line, some ten miles to their rear.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0056-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("167ww2/5 Major General Dudley Ward, commander 4th Infantry Division.")])])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0056-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("169ww2/5 A Canadian Sherman crossing one of three bridges (this one a Bailey bridge) thrown across the Gari River. A smoke screen covers the bridge from the eyes of the defending troops of "), _c('i', [_vm._v("Panzergrenadier Regiment 115")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0056-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("168ww2/5 Major General Dudley Russell, commander 8th Indian Division.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0056-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("170ww2/5 Shermans of B Squadron 17th/21st Lancers, 78th Division, formed up in the Piopetto valley ready to advance. The squadron leader, Major Buxton, is directing his men by radio from the Sherman on the hillside.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0056-05.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("171ww2/5 Captain Richard Wakeford 2nd/4th Battalion, The Hampshire Regiment, 4th Division. VICTORIA CROSS.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Citation:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("On 13th May, 1944, Captain Wakeford commanded the leading Company on the right flank of an attack on two hills near Cassino, and accompanied by his orderly and armed only with a revolver, he killed a number of the enemy and handed over twenty prisoners when the Company came forward. On the final objective a German officer and five other ranks were holding a house. After being twice driven back by grenades. Captain Wakeford, with a final dash, reached the window and hurled in his grenades. Those of the enemy, who were not killed or wounded, surrendered. Attacking another feature on the following day, a tank became bogged on the start line, surprise was lost and the leading infantry were caught in the enemy’s fire, so that the resulting casualties endangered the whole operation. Captain Wakeford, keeping his Company under perfect control, crossed the start line and although wounded in the face and in both arms, led his men up the hill. Half way up the hill his Company came under heavy Spandau fire; in spite of his wounds, he organized and led a force to deal with this opposition so that his company could get on. By now the Company was being heavily mortared and Captain Wakeford was again wounded, in both legs, but he still went on and reaching his objective, he organized and consolidated the remainder of his Company and reported to his Commanding Officer before submitting to any personal attention. During the seven hour interval before stretcher-bearers could reach him his unwavering high spirits encouraged the wounded men around him. His selfless devotion to duty, leadership, determination, courage and disregard for his own serious, injuries were beyond all praise")]), _vm._v(".")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0057-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("065ww2/5 Universal carrier and mortar team of the Indian 6th Royal Frontier Force, between Lanciano and Osogna, on the central sector of Eighth Army’s front.")])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0057-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The KING has been graciously pleased to approve the award of the VICTORIA CROSS to: No. 35408 Sepoy Kamal Ram, 8th Punjab Regiment, Indian Army.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("In Italy, on 12 May 1944, after crossing the River Gari overnight, the Company advance was held up by heavy machine-gun fire from four posts on the front and flanks. As the capture of the position was essential to secure the bridgehead, the Company Commander called for a volunteer to get round the rear of the right post and silence it. Volunteering at once and crawling forward through the wire to a flank, Sepoy Kamal Ram attacked the post single handed and shot the first machine-gunner; a second German tried to seize his weapon but Sepoy Kamal Ram killed him with the bayonet and then shot a German officer who, appearing from the trench with his pistol, was about to fire. Sepoy Kamal Ram, still alone, at once went on to attack the second machine-gun post which was continuing to hold up the advance and, after shooting one machine-gunner, he threw a grenade and the remaining enemy surrendered. Seeing a Havildar")]), _vm._v(" [sergeant] "), _c('i', [_vm._v("making a reconnaissance for an attack on the third post, Sepoy Kamal Ram joined him, and, having first covered his companion, went in and completed the destruction of this post. By his courage, initiative and disregard for personal risk, Sepoy Kamal Ram enabled his Company to charge and secure the ground vital to the establishment of the bridgehead and the completion of work on two bridges. When a platoon, pushing further forward to widen the position, was fired on from a house, Sepoy Kamal Ram, dashing towards the house, shot one German in a slit trench and captured two more. His sustained and outstanding bravery unquestionably saved a difficult situation at a critical period of the battle and enabled his Battalion to attain the essential part of their objective")]), _vm._v(". London Gazette, "), _c('i', [_vm._v("27 July 1944")]), _vm._v(".")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0058-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("174ww2/5 Commander of the "), _c('i', [_vm._v("Corps Expéditionnaire Français")]), _vm._v(" (CEF), General Alphonse Pierre Juin. His expertise in mountain warfare was crucial in breaking the Gustav Line, which had held up the Allied advance for six months.")])])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0058-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("176ww2/5 Native Moroccan irregulars. They were recruited mainly from the fierce Berber tribesmen from the Atlas Mountains. They were under the command of French officers and NCOs. They were highly successful in fighting, but dangerously undisciplined. Most of the civilian population had been evacuated from Cassino area; however, in the push towards Rome, Italian women, girls and boys were raped and homes were plundered. General Juin ordered that the offenders be caught and punished. Around 360 were brought before the military courts for crimes committed against thousands of civilians. Some were executed, others were imprisoned. The French officers began clamping down with fierce brutality, shooting and hanging offenders.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0058-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("177ww2/5 Elements of the 3ème Division d’Infantierie Algérienne crossing a ford in the Liri valley. By the middle of May 1944 the French Corps had broken through the defences of the Gustav Line and outflanked the support defence position known as the Hitler Line. The Eighth Army on their right flank had not been able to keep up.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0058-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("175ww2/5 German prisoners being rounded up by the French. The French soldiers of Juin’s CEF are wearing a mixture of American and French equipment.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0059-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("178ww2/5 General Władysław Anders, commander of the Polish II Corps.")])])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0059-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Soldiers of the 5th Battalion, 2 Brigade, 3rd Carpathian Rifle Division, II Polish Corps returning from patrol. Soldiers in the Polish Corps were released by the Soviet Union following the German invasion of Russia in 1941. They travelled through Iran to British-ruled Palestine, where they passed under British command. Here, Anders formed and led the Polish II Corps, while continuing to agitate for the release of Polish nationals still in the Soviet Union. The Polish Corps became a major operational formation of the Polish armed forces in the West. Anders commanded the Corps throughout the Italian Campaign, capturing Monte Cassino on 18 May 1944,")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The II Polish Corps began its attack on Monte Cassino on 11 May 1944 and suffered heavy losses caused by the defenders, paratroopers of "), _c('i', [_vm._v("Fallschirmäger Regiment 3")]), _vm._v(". Allied soldiers had begun refering to the "), _c('i', [_vm._v("Fallschirmäger")]), _vm._v(" as the ‘Green Devils’. Six days later they attacked again and, as the Allies linked up, the Germans withdrew from the mountain. A patrol of the 12 Pułku Ułanów Podolskich (Podolski Regiment) entered the abbey ruins on 18 May and Kazimierz Gurbiela raised the Polish flag, followed shortly by the British flag. "), _c('i', [_vm._v("Plutonowy")]), _vm._v(" (platoon leader) Emil Czech climbed to the summit and whilst braving fire from retreating Germans he sounded out the "), _c('i', [_vm._v("Hejnał Mariacki")]), _vm._v(" (Kraków Anthem) on his bugle.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0059-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("180ww2/5 On the morning of the 17 May, Poles of the 2 Rifle Brigade, 3rd Carpathian Division, scaling the heights of Point 593, a German strongpoint.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0060-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("181ww2/5 At the Regimental Command Post, "), _c('i', [_vm._v("Generalleutnant")]), _vm._v(" Richard Heidrich, commander of the "), _c('i', [_vm._v("1.Fallschirmjäger Division")]), _vm._v(" (with map and field glasses), and "), _c('i', [_vm._v("Oberst")]), _vm._v(" Ludwig Heilmann, commander of "), _c('i', [_vm._v("Fallschirmjäger 3")]), _vm._v(". Defending Monte Cassino, with its bombed monastery, was the "), _c('i', [_vm._v("1.Battalion")]), _vm._v(". The officers are awaiting the visit of "), _c('i', [_vm._v("Generalfeldmarschall")]), _vm._v(" Kesselring.")])])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0060-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("183ww2/5 A group of defenders from "), _c('i', [_vm._v("Fallschirmjäger-Regiment 4")]), _vm._v(" look out for the next attack.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0061-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("187ww2/5,188ww2/5 Learning the lessons of previous assaults, General Anders decided his forces would focus on taking the high ground beyond the monastery. If they succeeded, the Germans’ hold on monastery hill and ruins would become increasingly difficult and bring about their withdrawal. German strongholds on the surrounding hills would be assaulted; they were named Point 575, Point 593, Point 569 and Point 505. The Kresowa Division was chosen to tackle Phantom Ridge; the Carpathian Division was to strike and seize Point 593 and then attack Point 569.")])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0061-02.jpg"
    }
  })])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0062-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("190ww2/5 To take on the Green Devils: Bren gun, 18 pounder anti-tank gun and Sherman tanks.")])])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0062-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("189ww2/5 Men of the Polish 3rd Carpathian Division, having retrieved the body of a fallen comrade, pass along the corpse strewn path next to the "), _c('i', [_vm._v("‘Domek Doktora’")]), _vm._v(" (the Doctor’s House). The house on Snakeshead Ridge served as a battalion headquarters and aid post. Casualties were high in the fighting for two German strongpoints, 593 and 569, which involved hand to hand fighting with paratroopers of "), _c('i', [_vm._v("Fallschirmjäger Regiment 3")]), _vm._v(".")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0063-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("184ww2/5 Some of the thirteen-man patrol of the Polish 12th Podolski Lancers who had advanced into the ruins of the monastery on the morning of 18 May to find the enemy had withdrawn. Thirty wounded "), _c('i', [_vm._v("Fallschirmjäger")]), _vm._v(" being tended by two medics were all that remained. The relief is evident on the faces of some of the patrol, commanded by Second Lieutenant Kasimierz Gurbiel (in forage cap and holding a Webley service revolver). Note the rubber boots worn by the patrol for more silent movement over the rocky terrain.")])])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0063-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("185ww2/5 Polish bugler Master Corporal Emil Czech playing the "), _c('i', [_vm._v("Hejnał mariacki")]), _vm._v(" (Saint Mary’s Dawn), announcing the victory at Monte Cassino, 18 May 1944. It was the traditional signal for the opening and closing of the Krakow city gates, once played daily at dawn and dusk.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0063-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("186ww2/5 The Polish national flag was hoisted as a sign of victory at 10.20 am. General Anders ordered that the Union Jack should be flown alongside it.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0064-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("191ww2/5 Dead British and German troops, killed at close-quarters, gives evidence of the brutal fighting on Monte Cassino. The rifle framing the photograph is a German "), _c('i', [_vm._v("Karabiner")]), _vm._v(" 98k ‘Mauser’ rifle (usually abbreviated to K98k).")])])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0064-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("192ww2/5 Lieutenant General Eedson Burns, commanding Canadian I Corps.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0064-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("193ww2/5 The city of Pontecorvo, captured by the Royal Canadian Regiment on 24 May. Canadian trucks driving through the ruins. The Allies had bombed the city on four occasions, trying to hit the bridge over the Liri.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0065-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("172ww2/5 Fusilier Francis Arthur Jefferson, C Company, 2nd Battalion, The Lancashire Fusiliers, 78th Division. An unusual photograph in that the perpetrator of the deed is pictured alongside the enemy StuG III he destroyed, along with its crew.")])])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("VICTORIA CROSS Awarded on: 13 July, 1944. Citation: "), _c('i', [_vm._v("On 16 May, 1944, during an attack on the Gustav Line, an anti-tank obstacle held up some of our tanks, causing the leading Company of Fusilier Jefferson’s Battalion to dig in on the hill without tanks or anti-tank guns. The enemy counter-attacked with infantry and two Mark IV tanks")]), _vm._v(", [actually two StuG III self-propelled guns] "), _c('i', [_vm._v("which opened fire at short range, causing a number of casualties and eliminating one P.I.A.T. group entirely. As the tanks advanced towards the partially dug trenches, Fusilier Jefferson, entirely on his own initiative, seized a P.I.A.T. and running forward alone under heavy fire, took up a position behind a hedge; as he could not see properly, he came into the open, and standing up under a hail of bullets, fired at the leading tank, which was now only twenty yards away. It burst into flames and all the crew were killed. Fusilier Jefferson then reloaded the P.I.A.T. and proceeded towards the second tank, which withdrew before he could get within range. By this time our own tanks had arrived and the enemy counter-attack was smashed with heavy casualties. Fusilier Jefferson’s gallant act not merely saved the lives of his Company and caused many casualties to the Germans, but also broke up the enemy counter-attack and had a decisive effect on the subsequent operation. His supreme gallantry and disregard of personal risk contributed largely to the success of the action")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0065-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("173ww2/5 A StuG III, knocked out by two shells from a Sherman, is examined by two British soldiers.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0066-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("194ww2/5 One of the weapons opposing the centre of the Canadians’ attack on the Hitler Line: a "), _c('i', [_vm._v("Pantherturm")]), _vm._v(", a Kpfw V Panther turret with its 75mm gun set in a concrete bunker. Hitler had the name of the defence position changed to the ‘Senger’ Line for propaganda reasons in case it fell to the Allies. Victims of the gun can be seen in the three Churchill tanks knocked out. Camouflaged in foliage, the position would have been difficult to spot for B Squadron of the British North Irish Horse, 51st Royal Tank Regiment, attached as part of the armoured support for the Princess Patricia’s Canadian Light Infantry.")])])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0066-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0066-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("196ww2/5 Corporal Thrasher of the Canadian Westminster Regiment standing on the "), _c('i', [_vm._v("Nashorn")]), _vm._v(" of "), _c('i', [_vm._v("Panzerjäger Abteilung 525")]), _vm._v(" he knocked out with his PIAT. The "), _c('i', [_vm._v("Nashorn")]), _vm._v(" (Rhinoceros), was a self-propelled 88mm gun on a Mk IV chassis.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The "), _c('i', [_vm._v("Pantherturm")]), _vm._v(" was a steel and concrete shelter dugout and mounted with a turret from a Panther Mark V. Its 75mm gun could rotate through a 360-degree field of fire and had a range of 1,200 yards. They were difficult to detect by aerial reconnaissance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 24 May three Stuart tanks of Lord Strathcona’s Horse, on reconnaissance, crossed the River Melfa and with A Company of the Westminster Regiment succeeded in establishing a bridgehead. The Germans counter attacked but they were repelled and during the fighting Corporal Thrasher put out of action the formidable "), _c('i', [_vm._v("Nashorn")]), _vm._v(". The following day, despite the Germans throwing in Panther tanks, it became clear that the battle for Monte Cassino was coming to an end.")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0067-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Westminster Regiment (Motor) cap badge. In early 1941 the unit was converted to a motor battalion and designated The Westminster Regiment (Motor). At the Battle of the Melfa River it fought in conjunction with the tanks of Lord Strathcona’s Horse (Royal Canadians). By the end of hostilities the regiment earned the reputation for never having failed to take an assigned objective.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0067-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("197ww2/5 Major John Keefer Mahony, commanded A Company, Westminsters. On 24 May 1944 Major Mahony led his company across the Melfa River under heavy artillery fire. His task was to secure a firm bridgehead on the western side of the river and was part of the operations by 1st Canadian Corps to break through the Hitler Line. Although threatened by superior forces, Mahony’s company managed to hold the bridgehead for five hours under continuous fire until reinforcements arrived. In two German counterattacks his men destroyed three enemy self-propelled guns and one tank – a significant feat, considering they had no anti-tank guns, only hand held PIATs. He suffered three wounds but carried on his command. The Victoria Cross citation reads that throughout Mahony was a constant source of inspiration and determination as he tirelessly organised the defence, visited his men in their positions, and personally directed the fire of the light anti-tank weapons on hand. For his exemplary leadership and courage in this action, Major Mahony was awarded the Victoria Cross.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0067-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("199ww2/5 The Canadian advance saw the first western Allies encounter with the deadly "), _c('i', [_vm._v("Kpfw V")]), _vm._v(", the Panther, inspired by the Russian T-34 with sloping armour. This Panther is lurking in an alley at Stazione di Roccasecca, on the road to Rome.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0067-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("200ww2/5 The British Columbia Dragoons had a clash with Panthers at Massa Mancini, three Panthers were destroyed for the loss of four Shermans. This was quite an achievement for the Canadians, who were hopelessly out-gunned by the Panthers.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0068-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("201ww2/5 Major General John Porter Lucas, commander of VI Corps during the Battle of Anzio (Operation Shingle).")])])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0068-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("084ww2/5, 089ww2/5. Pre dawn on 22 January 1944, Allied troops began landing on the beaches at Anzio and Nattuno.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0068-03.jpg"
    }
  })])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0069-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0069-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Lieutenant General Mark Wayne Clark,")]), _vm._v(" commander of the US Fifth Army.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0069-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_c('b', [_vm._v("Generaloberst")])]), _vm._v(" "), _c('b', [_vm._v("Eberhard von Mackensen,")]), _vm._v(" commander of the "), _c('i', [_vm._v("Fourteenth Army")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The landings at Anzio went smoothly and with little German resistance. The commander of VI Corps, Major General Lucas, had the opportunity to move out of the beach head and sever the supply lines of the German Tenth Army. He failed to seize the opportunity, deciding instead to wait until the beachhead had been fully secured. Following the landing on 22 January 1944, eight crucial days lapsed before Lucas ordered an advance on Cisterna and Campoleone. It was too late. "), _c('i', [_vm._v("Feldmarschall")]), _vm._v(" Albert Kesselring, on orders from Hitler, had rushed troops to Italy. On 31 January 1944 eight German divisions surrounded the Allied beach head. On 6 February the German Fourteenth Army, under General Eberhard von Mackensen began the process of annihilating the invaders. On 16 February six German divisions launched a counter attack. Overwhelming firepower from the air, ground artillery and offshore ships’ batteries halted the Germans.")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0070-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("079ww2/5 The beach at Anzio and its small harbour were in operation on the afternoon of the landing. Engineers of the 36th Combat Regiment matting the churned up ground.")])])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0070-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("085ww2/5 Some of the 227 Germans taken prisoner on the first day await their turn to be marched down to ships returning to Naples. Their facial expressions are of interest; also the varied dress and ages of the captives.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0070-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("087ww2/5 American troops pushing eastwards to deepen the bridgehead. A drainage canal – the "), _c('i', [_vm._v("Mussolini Canale")]), _vm._v(" – defended the right flank of Allied beachhead. It remained so until the breakout in May.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0071-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("083ww2/5 An American artillery camp just off the beach at Anzio.")])])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0071-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("096ww2/5 Seen inspecting the German positions surrounding the Allied landings at Anzio, "), _c('i', [_vm._v("Generalfeldmarschall")]), _vm._v(" Albert Kesselring and his Chief of Staff, "), _c('i', [_vm._v("General der Kavallerie")]), _vm._v(" Siegfried Westphal. It was observed that the Allies were not advancing to extend their beachhead; there would be time to bring up reinforcements to oppose the landing.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0071-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("078ww2/5 Men of either the US 504th or 509th Parachute Infantry Regiments being briefed for a patrol at their headquarters on the beach at Anzio.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0072-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("1. Covering fire is laid down on the cluster of farm buildings.")])])])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("A captured order found on a German prisoner stated that the Germans in Anzio would be")]), _vm._v(" "), _c('i', [_c('b', [_vm._v("‘fighting an elite Canadian-American Force’. They are treacherous, unmerciful and clever. You cannot afford to relax. The first soldier or group of soldiers capturing one of these men will be given a ten-day furlough.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0072-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("2. Approach is made through a copse of silver birch saplings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0072-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("3. The German position in the large barn is suddenly rushed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0072-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("4. Finally, soldiers inside firing towards a haystack after the last enemy had been either killed or had withdrawn.")])])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0073-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A group of four photographs depicting a typical action by the First Special Service Force attacking a farm occupied by the Germans. The special unit operated in a position on the right flank of the Anzio beachhead, along the boundary created by the Mussolini Canal.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0073-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("225ww2/5 Men of the First Special Service Force being briefed before setting out on a patrol in the Anzio beachhead.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0073-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The First Special Service Force was an elite American–Canadian commando unit under the command of the United States Fifth Army. The unit insignia was a scarlet arrow head with white lettering, worn on the left upper arm.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0073-04.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0073-05.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("224ww2/5 The few German forces in the Anzio-Nettuno area at the time of Allied landing were soldiers of the "), _c('i', [_vm._v("90.Panzergrenadier Division")]), _vm._v(", battalions of "), _c('i', [_vm._v("Oberst")]), _vm._v(" Heinrich Baron von Behr’s "), _c('i', [_vm._v("Panzergrenadier Regiment 200")]), _vm._v(". An original caption for the two Germans indicates they were in the Anzio area during the early days of the landing. Interestingly, they are pictured standing in a copse of young trees similar to the ones in picture 2 above and appear to have recently been in a battle.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0074-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0074-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("218ww2/5, 221ww2/5, 222ww2/5. Lieutenant Colonel William Orlando Darby. When the United States Army decided to form a Rangers force styled on the British Commandos, Darby was put in command of the new formation: the 1st Rangers Battalion. In November 1942, the battalion entered combat for the first time when it landed in Algeria. The operation was successful and was followed by further military achievements against the Italians. Two more battalions were formed, the 3rd and 4th. They performed well as assault troops in the invasion of Sicily and subsequent fighting. They were landed at Anzio. Rangers climbing into landing craft for an assault on the coast. Left, a Ranger in full marching order and ready to move to a new base position.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0074-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 30 January 1944 the Rangers were brought together to capture Cisterna, inland from Anzio. That night the 1st and 3rd Battalions moved towards their objective along a landscape feature called the Pantano Ditch. The 4th Ranger Battalion met opposition almost immediately when moving along a direct route by road to Cisterna. During the night advance the 1st and 3rd Ranger Battalions became spread out over a distance of two miles. Daylight caught the 1st Ranger Battalion out in an open field. The Germans were waiting for them in a prepared ambush; Darby’s force had run into the crack "), _c('i', [_vm._v("Hermann Göring Panzer Division")]), _vm._v(" and "), _c('i', [_vm._v("4.Fallschirmjäger Division")]), _vm._v(". Completely surrounded, the two Ranger battalions fought on until ammunition and resources were exhausted. The 4th Ranger Battalion made a push to save their comrades but was unsuccessful and had to withdraw. After five hours of fighting, German tanks and motorised infantry defeated the Rangers. Out of the 760 men in the two battalions, only six escaped and the rest were killed or captured. This marked the end of the three Ranger battalions. The remaining 400 Rangers were transferred to the 504th Parachute Infantry Regiment. Others were sent home. On 26 October 1944, the three original Ranger battalions were deactivated at Camp Butner, North Carolina.")])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0075-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("220ww2/5, 223ww2/5. Some 2,000 captured American and British prisoners of war were transported to Rome and herded into the Colosseum. Among them were the Rangers taken in the disastrous attack on Cisterna. The Germans paraded the large bag of captured Allied soldiers through the streets of Rome. Jeering Italians threw sticks, stones and rotten food at them while those sympathetic to the Allies’ cause cheered them with discreet ‘V’ signs.")])])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0075-02.jpg"
    }
  })])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0076-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Sergeant Truman O. Olson 7th Infantry Regiment, 3rd Infantry Division")])])])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("On 30 January 1944, near Cisterna di Littoria, Sergeant Truman O. Olson participated in the Battle of Cisterna. After a day of fighting which resulted in heavy casualties, what remained of his company dug in with Olson and his gun crew manning a light machine gun. During the night, his entire gun crew was killed or wounded and Olson himself was wounded in the arm. Despite this, he remained at his post and manned the gun alone for the rest of the night.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He was posthumously awarded the Medal of Honor,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("For conspicuous gallantry and intrepidity above and beyond the call of duty. Sergeant Olson, a light machine gunner, elected to sacrifice his life to save his company from annihilation. On the night of 30 January 1944, after a 16-hour assault on entrenched enemy positions in the course of which over one-third of Company B became casualties, the survivors dug in behind a horseshoe elevation, placing Sergeant Olson and his crew, with the one available machine gun, forward of their lines and in an exposed position to bear the brunt of the expected German counterattack. Although he had been fighting without respite, Sergeant Olson stuck grimly to his post all night while his gun crew was cut down one by one, by accurate and overwhelming enemy fire. Weary from over twenty-four hours of continuous battle and suffering from an arm wound, received during the night engagement, Sergeant Olson manned his gun alone, meeting the full force of an all-out enemy assault by approximately 200 men supported by mortar and machine-gun fire which the Germans launched at daybreak on the morning of 31 January. After thirty minutes of fighting, Sergeant Olson was mortally wounded, yet, knowing that only his weapon stood between his company and complete destruction, he refused evacuation. For an hour and a half after receiving his second and fatal wound he continued to fire his machine gun, killing at least twenty of the enemy, wounding many more and forcing the assaulting German elements to withdraw")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He had suffered serious shrapnel wounds in his back and left leg. His wounds were so severe that he died while being stretchered to the rear.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0076-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("073ww2/5 Time spent by the commander of US VI Corps, Major General Lucas, strengthening his position at the beachhead had given the Germans much needed breathing space to bring in reinforcements to launch a counter-attack. A Mk IV panzer packed with panzergrenadiers heads for an assembly area from which an attack is to be launched. Hitler had ordered that the ‘abscess below Rome must be removed’.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0077-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("077ww2/5, 219ww2/5 These photographs have sometimes been captioned as being troops of the "), _c('i', [_vm._v("Herman Göring Panzer Division")]), _vm._v("; however, they could have belonged to "), _c('i', [_vm._v("Panzer Regiment 4")]), _vm._v(". The Panther MkVs and StuG could indicate "), _c('i', [_vm._v("3.Panzergrenadier Division")]), _vm._v(". The confusion is likely caused by the mixture of uniforms. In the lower picture they are passing a ‘Ferdinand’ (name ‘changed to ‘Elefant’ in May 1944) "), _c('i', [_vm._v("Panzerjäger Tiger (P)")]), _vm._v(" tank destroyer.")])])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0077-02.jpg"
    }
  })])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0078-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("092ww2/5 A "), _c('i', [_vm._v("Sturmpanzer IV")]), _vm._v(" or "), _c('i', [_vm._v("Brummbär")]), _vm._v(", with a 150mm gun, passing a "), _c('i', [_vm._v("schwere Panzerabteilung 508")]), _vm._v(" Tiger. The heavy ("), _c('i', [_vm._v("schwere")]), _vm._v(") tank unit during its operations against the Allied beachhead proved to be a disappointment. Finally, after losing twenty-two tanks on the withdrawal towards Rome in May, due mainly to breakdowns, the commander, Major Hudel, was recalled to Germany and reassigned to a second line command.")])])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0078-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("227ww2/5 Major Helmut Hedel, commander of "), _c('i', [_vm._v("Schwere Panzerabteilung 508")]), _vm._v(", was recalled by Hitler and replaced.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0078-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("066ww2/5 A "), _c('i', [_vm._v("PzKpfw VI Ausf. H Tiger")]), _vm._v(" undergoing maintenance, jacked-up and resting on blocks, in the Nettuno area, thirty-seven miles south of Rome. This Tiger belongs to "), _c('i', [_vm._v("Schwere PanzerAbteilung 508")]), _vm._v(" and was involved in the containment of the Allied Anzio landings. Breakdowns were constant, whilst the poor conditions of the narrow roads made movement difficult, as did the Allied artillery, air support and off shore guns of the Allied navies.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0079-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("076ww2/5 Two Krupp K5 heavy railway guns, named ‘Robert’ and ‘Leopold’ by their German crews, arrived in Italy to help counter the Allied landing at Anzio. Allied soldiers in the beachhead named the two guns ‘Anzio Annie’ and ‘Anzio Express’ (incoming shells made a noise like an express train). On 18 May 1944 the guns fired off their remaining ammunition and then rumbled along the coastal rail track into the rail yard in Civitavecchia, forty miles north of Rome. On 7 June 1944, shortly after the allies occupied Rome, ‘Robert’ was destroyed by the gun crew and, likewise, ‘Leopold’ was seriously damaged. The weapon had a range of forty miles.")])])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0079-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("074ww2/5 Men of the elite "), _c('i', [_vm._v("Hermann Göring Division")]), _vm._v(" operating a 75mm PaK 40 anti-tank gun in Italy.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0080-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Winston Churchill was furious with Lucas and commented "), _c('i', [_c('b', [_vm._v("‘I had hoped that we were hurling a wildcat onto the shore, but all we got was a stranded whale.")])]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Allies had landed unopposed at Anzio and Nettuno. Alexander wanted Lucas to advance and secure the nearby Alban Heights. With forces insufficient to seize and hold both the Alban Heights and the beachhead, Lucas chose to stay in Anzio. The Germans quickly surrounded the beachhead, turning Anzio into a holding camp.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0080-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Major General John Porter Lucas, the cautious commander of VI Corps. He was replaced by his deputy commander, Lieutenant General Lucian K. Truscott, on 17 February, 1944.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0080-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("086ww2/5 Stalemate: The Germans were unable to throw the US VI Corps back into the sea but the two Allied divisions were incapable of breaking out of their beachhead at Anzio. Artillery fire on both sides continued to pound each other’s positions. The scene below, taken within the beachhead, is reminiscent of the trenches of the Great War of 1914-1918, with men living in foxholes.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0081-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("232ww2/5 Mildred Gillars, the Berlin based ‘Axis Sally’. The willing mouthpiece of her mentor and lover, she was returned to the United States in 1949 and was indicted for treason tried and imprisoned for twelve years.")])])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("An article in the Saturday Evening Post, January 1944, a Corporal Edward van Dyne wrote: "), _c('i', [_vm._v("‘There’s No Other Gal Like Axis Sal’")]), _vm._v(", and went on, "), _c('i', [_vm._v("‘Axis Sally is a different proposition. Sally is a dandy – the sweetheart of the AEF")]), _vm._v(" [Allied Expeditionary Force]. "), _c('i', [_vm._v("She plays nothing but swing, and good swing!’")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rita Zucca, an Italian-American, signed onto each show by uttering her silky introduction: "), _c('i', [_c('b', [_vm._v("Hello Suckers!")])]), _c('b', [_vm._v("’")]), _vm._v(" As the Allied armies liberated Rome, Zucca retreated north with the Germans and resumed broadcasting from Milan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before the invasion of Sicily, Zucca told her listeners: "), _c('i', [_c('b', [_vm._v("You wonderful boys of the 504th Parachute Regiment, Colonel Willis Mitchell’s playboys")])]), _vm._v(" [the 61st Troop Carrier Group] "), _c('i', [_c('b', [_vm._v("are going to carry you to certain death. We know where and when you are jumping and you will be wiped out.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_c('b', [_vm._v("Axis Sally")])]), _vm._v(". From the deserts of North Africa to the dogged fighting up the leg of Italy and to the Normandy beaches, Allied soldiers tuned in to the sensual voice of an American woman broadcasting on behalf of Nazi Germany. The seductive voice mused aloud if their wives and girlfriends back home were being unfaithful and gently pointed out the benefits of surrender. The men tried to imagine the mysterious beauty behind the microphone. She cultivated a persona of sexual allure, ready to welcome the boys and understand their troubles.The swing music she played kept them tuning in.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The reality behind the voice was in fact two American women competing for the soldiers’ fantasies: Mildred Gillars, a middle aged former showgirl from Ohio, based in Berlin; the other, a cross-eyed thirty-year old New Yorker with a honeyed voice named Rita Zucca, broadcasting from Rome. Both women morphed into one personality – "), _c('i', [_c('b', [_vm._v("Axis Sally")])]), _vm._v(" – for their military audience.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Her message to the troops concerning Anzio was that their beachhead was, "), _c('i', [_c('b', [_vm._v("‘the largest self-supporting prisoner of war camp in the world’")])]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0081-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("231ww2/5 Rita Zucca, broadcast from Rome and was motivated by the money. Tried by an Italian court in 1946 and sentenced to four and a half years. She was released after nine months.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0081-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("233ww2/5 GIs enjoying the enemy propaganda, not quite the effect Minister for Propaganda Joseph Göbbels anticipated.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0082-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("217ww2/5 February 19 during the German major offensive against the beachhead, Operation "), _c('i', [_vm._v("Fischfang")]), _vm._v(": German prisoners of "), _c('i', [_vm._v("114.Jäger Division")]), _vm._v(", marching in single file with an "), _c('i', [_vm._v("oberfeldwebel")]), _vm._v(" leading, pass through a gauntlet of American soldiers in foxholes, men of the US 3rd Infantry Division. The taunts and ‘wisecracks’ taking place can be imagined. By the 20th the German offensive had been defeated, with 5,389 killed, wounded and missing. VI Corps had taken 609 prisoners.")])])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0082-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("234ww2/5 Following up on the German Fourteenth Army retreat from the Gustav Line, this team of men from the US Fifth Army follow with supplies, May 1944.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0083-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("235ww2/5 An armoured patrol in the ruins of Cassino. The Germans had pulled back from the Gustav Line under pressure from the French and Poles. As the Germans withdrew, the American forces in south flank of the Anzio beachhead had, in the opinion of many, an opportunity of hitting the withdrawing forces. However, as some point out, the eye of General Mark Clark seemed to be focused on the City of Rome.")])])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0083-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("236ww2/5 Brigadier William S. Ziegler, Commander of the Royal Artillery component of the 1st Canadian Infantry Division")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0083-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("075ww2/5 In the Anzio bridgehead a British artillery team loading a 4.5 inch field gun. It could fire a 55 lbs high explosive shell up to eleven miles. As the German Tenth Army began withdrawing from the the Gustav Line around Cassino a British artillery record was established on 23 May. Canadian Royal Artillery Brigadier William Smith Ziegler called for a ‘William Target’ against German forces assembling for a counter-attack. This was a call for the entire Eighth Army artillery to bring fire down. Thirty-three minutes later over six hundred guns suddenly opened up together and in the next two minutes 3,500 shells smashed onto the target. The German attack did not go ahead.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0084-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Japanese Americans who fought in the Second World War were Nisei (a Japanese word meaning born in the United States to immigrant parents). Following the Imperial Japanese Navy’s attack on Pearl Harbor on 7 December 1941, Japanese-American men were, initially, categorized as enemy aliens (4C) and not subject to being drafted into the armed forces. In March 1942 a military proclamation occurred that resulted in the forced relocation from their homes and businesses of 110,000 American citizens of Japanese ancestry. They were moved to guarded concentration camps. Two-thirds of them were born in the United States.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0084-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Colonel Charles W. Pence, "), _c('b', [_vm._v("442nd Team Commander")]), _vm._v(". Citation for the Award of the Army Distinguished Service Medal to Colonel Pence, "), _c('i', [_vm._v("by wise, efficient and inspiring leadership, placed on the battlefields of Italy and France an organization which proved in conflict to be one of the best units in the American Army, the 442nd Regiment")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("President Roosevelt announced the formation of the "), _c('b', [_vm._v("442nd Infantry Regimental Combat Team")]), _vm._v(", saying, "), _c('i', [_vm._v("‘Americanism is not, and never was, a matter of race or ancestry’")]), _vm._v(". The Army called for 2,900 Nisei men from Hawaii, and 1,500 from the mainland. Ultimately, the draft obtained further Japanese Americans from the mainland and these made up a large part of the 14,000 men who eventually served in the 442nd Regiment. .")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0084-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("442nd Regimental Combat Team insignia.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0085-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("228ww2/5 Nisei troops of the 100th Battalion, 442nd Regiment landed at Anzio on 28 May, 1944. The 442nd Nisei would join the 100th Battalion north of Rome at Civitavecchia on 11 June 1944, attached to the 34th Infantry Division. Seen here a Japanese ancestry soldier escorting German prisoners in Italy.")])])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The 442nd Regiment is the most decorated unit for its size in US military history. Created as the 442nd Regimental Combat Team when it was activated on 1 February 1943, the unit grew to its fighting complement of 4,000 men by April 1943. An eventual total of 14,000 men served overall. The unit including the 100th Infantry Battalion, which earned more than 18,000 awards in less than two years, including more than 4,000 Purple Hearts and 4,000 Bronze Star Medals. The unit was awarded eight Presidential Unit Citations. Remarkable for men once classed as ‘enemy aliens’.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0085-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("209ww2/5 An American M10 tank destroyer on the outskirsts of Rome. The Germans had declared it to be an open city and withdrawn.")])])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0086-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_vm._v("St Peter’s Square, Rome, General Mark Clark and his men in a victorious pose as liberators.")]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_vm._v("The Germans had declared Rome an ‘Open City’ and left.")]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_vm._v("Men of the 1st Battalion, Duke of Wellington’s Regiment march into Rome on 8 June 1944. Clark had kept the British out while he staged his own triumphal procession on the 5th. But events in Italy had already been overshadowed by the Allied invasion of")]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_vm._v("Normandy. From now on, the Italian campaign would be a strategic backwater.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0086-02.jpg"
    }
  })])]), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0087-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("244ww2/5 A Royal Air Force photographic reconnaissance Spitfire. German coastal defences were overflown regularly from Calais to Normandy during Allied preparations for the invasion of Europe.")])])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5f6bd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_chapter01.vue
// module id = 81
// module chunks = 0